import { formatDuration } from "@roxpacer/core";
import { useAuth } from "../auth";
import { LegEditor } from "../components/LegEditor";
import { PlanSettings } from "../components/PlanSettings";
import { PlanToolbar } from "../components/PlanToolbar";
import { SplitChart } from "../components/SplitChart";
import { SplitTable } from "../components/SplitTable";
import { Summary } from "../components/Summary";
import { useEstimate } from "../lib/use-estimate";
import { useActivePlan } from "../store";
import { useSyncStatus } from "../sync/engine";

export function PlannerPage() {
  const plan = useActivePlan();
  const estimate = useEstimate(plan);
  const signedIn = useAuth((s) => s.status === "signed-in");
  const syncMessage = useSyncStatus((s) => (s.status === "error" ? s.message : null));

  return (
    <div className="pb-20 lg:pb-10">
      <main className="mx-auto max-w-6xl space-y-4 px-4 pt-4">
        {syncMessage && (
          <p role="alert" className="card border-danger/40 px-4 py-2 text-sm text-danger">
            {syncMessage}
          </p>
        )}
        <PlanToolbar />
        <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_380px] lg:items-start">
          <div className="space-y-4">
            <PlanSettings />
            <LegEditor />
          </div>
          <aside className="space-y-4 lg:sticky lg:top-4">
            <Summary plan={plan} />
            <SplitChart plan={plan} />
            <SplitTable plan={plan} />
          </aside>
        </div>
        <footer className="py-6 text-center text-xs text-muted">
          {signedIn ? "Plans are saved to your account." : "Plans are saved in this browser."} Not
          affiliated with HYROX.
        </footer>
      </main>

      <div
        className="fixed inset-x-0 bottom-0 flex items-center justify-between border-t border-line bg-surface/95 px-4 py-3 backdrop-blur lg:hidden"
        aria-hidden
      >
        <span className="label">Estimated finish</span>
        <span className="text-xl font-semibold tabular-nums">
          {formatDuration(estimate.totalSec, { alwaysHours: true })}
        </span>
      </div>
    </div>
  );
}
